<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>

  <div class="row" *ngIf="BillsList">
    <div class="col-md-12 padding-right-0px padding-left-0px margin-top-10">
      <div class="card">
        <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
          <div class="row">
            <div class="col-md-3">
              <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Treatment Cycles</label>
            </div>
            <div class="col-md-7 text-align-right padding-left-0px padding-right-0px">
              <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
              <!--<button type="submit" class="btn btn-secondary actions-btn-prime float-right font-size-13px margin-right-auto">Convert To Ivf&#64;Home</button>-->

              
            </div>
          </div>
        </div>
        <div class="card-body padding-all-0px">
          <div class="row margin-left-10px">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="">
                          PID
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <th class="">
                          Cycle#
                        </th>

                        <th class="padding-left-4">
                          Name
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->




                        <th class="">
                          Contact
                        </th>
                        <th class="padding-left-9px">
                          Sex &amp; Age
                        </th>

                        <th></th>
                        <th>Protocol</th>
                        <th>Prtcl Start Date</th>
                        <th class="padding-left-10px">Cycle Type</th>
                        <th>Duration</th>

                        <th>Status</th>
                        <th></th>



                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentTreatmentCyclesController">

                        <td class="td-padding-tb padding-top-0px padding-bottom-0px padding-right-0px"> <a (click)="ViewPatientDetails(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i> {{l.PatientRegNo}}</a>  </td>
                        <!--<td class="td-padding text-align-center">Mon</td>-->
                        <td class=" padding-top-0px padding-bottom-0px text-align-right ">
                          {{l.CycleNo}}
                        </td>
                        <td class="td-padding padding-top-0px padding-bottom-0px ">
                          {{l.DisplayName}}
                        </td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Telephone1}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Gender}} &amp; {{l.Age}}</td>

                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.TCModelName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolStartDate| date:'MMM-dd-yyyy'}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px ">{{l.CycleType}}</td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Duration}} days</td>

                        <td class="padding-top-0px padding-bottom-0px">{{l.RecordStatus}}</td>


                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">
                          <button (click)="UpdateStatus(l)" class="btn actions-btn-prime font-size-13px">Update Status </button>

                        </td>



                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  

      <router-outlet></router-outlet>
      <router-outlet name="print"></router-outlet>
    </div>

    <!--<div class="row" *ngIf="Formedit">
    <div class="col-md-8 padding-left-0px">


      <div class="card">

        <div class="card-body padding-all-0px">
          <div *ngIf="FormData" class="margin-top-10">


            <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

              <div [id]="'accordion'+RowIndex">
                <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                  <div class="row">
                    <div class="col-md-3">
                      <h5 class="mb-0">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                          {{l.Title}}

                        </button>

                      </h5>
                    </div>
                    <div class="col-md-9">
                      <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                      <button type="button"
                              (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>
                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                     [attr.data-parent]="'#accordion'+RowIndex">
                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                    <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                      <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                        {{f.Title}}
                      </div>
                      <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                        <div *ngIf="f.isSubHeader">
                          <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                        </div>


                        <div *ngIf="f.isTextField">
                          <div class="row form-group">
                            <div class="col-md-3 padding-right-0px text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>


                        </div>
                        <div *ngIf="f.isSubChild">
                          <div class="row form-group">
                            <div class="col-md-3 text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>:
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>
                        </div>


                        <div *ngIf="f.Remarks">
                          <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                        </div>
                        <div *ngIf="f.HasSeparator">
                          <div class="border-bottom-light"></div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">

    </div>
  </div>-->
    <!--<div class="row">
    <div class="col-md-12">
      <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
    </div>

  </div>-->
